
























import { Component, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import CollapsibleBox from "@/components/CollapsibleBox.vue";
import { GuardileoVueComponent } from "@/lib";
import Vorfallmanagement from "@/Vorfallmanagement/api/Vorfallmanagement";
import VorfallmanagementApi from "@/Vorfallmanagement/api/api-vfmt";
import FileSaver from "file-saver";
import { confirmDeletion } from "@/helper/global-helper";
import UserNameDisplay from "@/components/UserNameDisplay.vue";

@Component({
    components: { CollapsibleBox, UserNameDisplay },
})
export default class KorrespondenzAnhangVfmt extends GuardileoVueComponent {
    @Prop({ default: false }) showDelete!: boolean;
    @Prop({ default: true }) sendRequestOnDelete!: boolean;
    @Prop() anhang!: Vorfallmanagement.Korrespondenz["Anhaenge"][0];
    private readonly api = new VorfallmanagementApi();

    async downloadFile() {
        try {
            const data = await this.api.GetAnhang(this.anhang.Guid);
            FileSaver.saveAs(data, this.anhang.FileName);
        } catch (error) {
            throw error;
        }
    }

    async removeFile() {
        try {
            confirmDeletion(
                this.$t("Korrespondenz.Anhang löschen"),
                this.$t("Korrespondenz.Möchten Sie diesen Anhang wirklich löschen?"),
                this.$t("Korrespondenz.Anhang löschen"),
                this.$t("Allgemein.Abbrechen"),
                async () => {
                    if (this.anhang.Datum) {
                        await this.api.AnhangLoeschen(this.anhang.Guid || this.anhang.Id);
                    }
                    this.$emit("deleted", this.anhang.Id);
                },
                () => {}
            );
        } catch (error) {
            throw error;
        }
    }
}
